// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z3ao","content":"styles_content__3uEk_","tableWrap":"styles_tableWrap__3vqfd"};